import React from "react";

const UnArchive = ({
  color = "#183243",
  width = "30",
  height = "30",
  strokeWidth = "0.5",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.25"
        y="0.25"
        width="29.5"
        height="29.5"
        rx="1.75"
        fill="white"
        stroke="black"
        strokeWidth={strokeWidth}
      />
      <g clipPath="url(#clip0_3055_2622)">
        <path
          d="M22.4062 9.573H8.59375C8.275 9.573 8.0625 9.7855 8.0625 10.1042V13.1324C8.0625 13.4511 8.275 13.6636 8.59375 13.6636H9.07187V22.9074C9.07187 23.2261 9.28437 23.4386 9.60312 23.4386H21.3968C21.7156 23.4386 21.9281 23.2261 21.9281 22.9074V13.6636H22.4062C22.7249 13.6636 22.9374 13.4511 22.9374 13.1324V10.1042C22.9374 9.83862 22.7249 9.573 22.4062 9.573ZM20.8656 22.4292H10.1344V13.6636H20.8656V22.4292ZM21.8749 12.6011H9.12499V10.6355H21.8749V12.6011Z"
          fill="black"
        />
      </g>
      <path
        d="M15.0022 4.13724L12.5642 6.58698C12.3816 6.77047 12.3823 7.06726 12.5658 7.2499C12.7493 7.43253 13.0461 7.43183 13.2287 7.24833L14.8652 5.60386V16.531C14.8652 16.7899 15.0751 16.9998 15.334 16.9998C15.5929 16.9998 15.8027 16.7899 15.8027 16.531V5.60389L17.4392 7.24831C17.6218 7.4318 17.9186 7.43251 18.1021 7.24988C18.2856 7.06723 18.2863 6.77042 18.1037 6.58695L15.6662 4.13764C15.483 3.95405 15.1848 3.95422 15.0022 4.13724Z"
        fill={color}
      />
      <defs>
        <clipPath id="clip0_3055_2622">
          <rect
            width="16.9999"
            height="17"
            fill="white"
            transform="translate(7 8.03235)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default UnArchive;
